import $ from 'jquery';

export default class OverlayController {
    constructor() {
        this.MODALS_SELECTOR = '.modal.fade';
        this.TRIGGER_SELECTOR = '.sos-overlay-trigger';
        this.NBA_SELECTOR = '.navbar .sos-nba';
        this.NBA_SELECTOR_FLOATING = '#footer-nba-content';
        this.NBA_SELECTOR_FLOATING_WRAPPER = '#footer-nba';

        this.initNBAContainers();
        this.createModalsFromNbas();
        this.registerClickEvents();
        this.positionModals();
        this.setNBAFooterClasses();
    }

    initNBAContainers() {
        /* eslint-disable-next-line */
        $.each(nbaConfig.buttons, (index, value) => {
            if (value.position === 'Footer') {
                // is element postioned inside footer container
                if (!$(this.NBA_SELECTOR_FLOATING).length) {
                    // footer container not already exists
                    $('body').append('<div id="footer-nba"><div id="footer-nba-content"></div></div>'); // append footer container to body
                }
            }
        });
    }

    createModalsFromNbas() {
        /* eslint-disable-next-line */
        $.each(nbaConfig.buttons, (index, value) => {
            let nbaButton;
            const responsiveClassName = OverlayController.getResponsiveNBAClasses(value);
            if (value.overlay) {
                nbaButton = `<div data-url='${value.url.toLowerCase()}' class='sos-overlay-trigger ${responsiveClassName} btn nba-btn ${value.buttonShape} ${value.color ? value.color : ''} ${
                    value.icon ? 'nba-hasimage' : ''
                }'>`;
                if (typeof value.icon !== 'undefined') nbaButton += `<img class='nba-icon' src='${value.icon}'>`;
                nbaButton += `${value.text}</div>`;
            }
            else {
                nbaButton = `<a href='${value.url}' class='btn ${value.buttonShape} nba-btn ${responsiveClassName} ${value.color ? value.color : ''} ${value.icon ? 'nba-hasimage' : ''}'>`;
                if (typeof value.icon !== 'undefined') nbaButton += `<img class='nba-icon' src='${value.icon}'>`;
                nbaButton += `${value.text}</a>`;
            }

            if (value.position === 'Footer') {
                $(this.NBA_SELECTOR_FLOATING).append(nbaButton);
            }
            else {
                $(this.NBA_SELECTOR).append(nbaButton);
            }
        });
    }

    static getResponsiveNBAClasses(nbaButton) {
        let className = '';
        if (!nbaButton.showMobile) className += 'hidden-xs';
        if (!nbaButton.showTablet) className += ' hidden-sm';
        if (!nbaButton.showDesktop) className += ' hidden-lg';
        return className;
    }

    setNBAFooterClasses() {
        let mobileFooterBtnsCount = 0;
        let tabletFooterBtnsCount = 0;
        let desktopFooterBtnsCount = 0;

        /* eslint-disable-next-line */
        $.each(nbaConfig.buttons, (index, value) => {
            if (value.position === 'Footer') {
                if (value.showMobile) mobileFooterBtnsCount += 1;
                if (value.showTablet) tabletFooterBtnsCount += 1;
                if (value.showDesktop) desktopFooterBtnsCount += 1;
            }
        });

        let className = '';
        if (mobileFooterBtnsCount < 1) className += 'hidden-xs';
        if (tabletFooterBtnsCount < 1) className += ' hidden-sm';
        if (desktopFooterBtnsCount < 1) className += ' hidden-lg';

        $(this.NBA_SELECTOR_FLOATING_WRAPPER).addClass(className);
    }

    registerClickEvents() {
        $(this.TRIGGER_SELECTOR).click((event) => {
            event.preventDefault();
            const dataUrl = event.target.dataset.url.toLowerCase();
            $(`.modal[data-url="${dataUrl}"]`).first().modal({ show: true });
        });
    }

    positionModals() {
        // ensure all modals are 1st level child of body
        $(this.MODALS_SELECTOR).appendTo(document.body);
    }

    static init() {
        $(document).ready(() => {
            new OverlayController(); // eslint-disable-line no-new
        });
    }
}
